<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <el-radio-group size="mini" v-model="relateType">
        <el-radio-button label="0">我使用的</el-radio-button>
        <el-radio-button label="1">我负责的</el-radio-button>
        <el-radio-button label="2">我的待盘点资产</el-radio-button>
      </el-radio-group>
    </div>
    <el-table v-if="relateType!=2" :data="paginationData" style="width: 100%" v-loading="loading">
      <!-- <el-table-column type="selection" width="25px">
      </el-table-column> -->
      <el-table-column prop="number" label="资产编号" width="160px">
      </el-table-column>
      <el-table-column label="资产名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <span v-if="relateType==0">
            <el-tag type="success" size="mini" v-if="scope.row.syStatus==1">已确认使用</el-tag>
            <el-tag type="danger" size="mini" v-else>未确认使用</el-tag>
          </span>
          <span v-if="relateType==1">
            <el-tag type="success" size="mini" v-if="scope.row.zrStatus==1">已确认责任</el-tag>
            <el-tag type="danger" size="mini" v-else>未确认责任</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="attribute.name" label="资产属性" width="90px">
      </el-table-column>
      <el-table-column prop="spec" label="规格型号" width="140px">
      </el-table-column>
      <el-table-column prop="price" label="购置金额" width="90px" align="center">
      </el-table-column>
      <el-table-column prop="purchaseTime" label="购置时间" width="80px">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom">
            <i @click="assetDetail(scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip>
          <el-tooltip class="item" v-if="relateType==0 && (scope.row.syStatus==0 || scope.row.syStatus==-1)"
            effect="dark" content="确认该资产确实我使用" placement="bottom">
            <i @click="assetConfirm(scope.row,0)" class="iconfont icon-duigou meeting-btn-icon mbi-edit"></i>
          </el-tooltip>
          <el-tooltip class="item" v-if="relateType==1 && (scope.row.zrStatus==0 || scope.row.zrStatus==-1)"
            effect="dark" content="确认该资产确实是我负责" placement="bottom">
            <i @click="assetConfirm(scope.row,1)" class="iconfont icon-duigou meeting-btn-icon mbi-edit"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="number" label="资产编号" width="160px">
      </el-table-column>
      <el-table-column label="资产名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <span v-if="relateType==0">
            <el-tag type="success" size="mini" v-if="scope.row.syStatus==1">已确认使用</el-tag>
            <el-tag type="danger" size="mini" v-else>未确认使用</el-tag>
          </span>
          <span v-if="relateType==1">
            <el-tag type="success" size="mini" v-if="scope.row.zrStatus==1">已确认责任</el-tag>
            <el-tag type="danger" size="mini" v-else>未确认责任</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="attribute.name" label="资产属性" width="90px">
      </el-table-column>
      <el-table-column prop="spec" label="规格型号" width="140px">
      </el-table-column>
      <el-table-column prop="price" label="购置金额" width="90px" align="center">
      </el-table-column>
      <el-table-column prop="purchaseTime" label="购置时间" width="80px">
      </el-table-column>
      <el-table-column label="盘点状态" width="80px" align="center">
        <template slot-scope="scope">
          <strong v-if="scope.row.panStatus==1" style="color:green">盘亏</strong>
          <strong v-else-if="scope.row.panStatus==0" style="color:red">盘盈</strong>
          <strong v-else-if="scope.row.panStatus==2">正常</strong>
          <strong v-else>未登记</strong>
        </template>
      </el-table-column>
      <el-table-column label="盘点操作" width="90px">
        <template slot-scope="scope">
          <el-button size="mini" @click="AssetPanVisible(scope.row)"
            v-if="!scope.row.panStatus || scope.row.panStatus=='-1'" type="primary">
            点击登记
          </el-button>
          <el-button size="mini" v-else type="info">已登记</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom">
            <i @click="assetDetail(scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>



    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <asset-detail></asset-detail>

    <!-- 登记盘点 -->
    <el-dialog title="资产盘点登记" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="form" label-width="90px" class="form" style="margin:-20px 0;padding:0;">
        <el-form-item label="盘点状态" class="required-label">
          <el-radio-group v-model="form.type">
            <el-radio-button label="0">盘盈</el-radio-button>
            <el-radio-button label="2">正常</el-radio-button>
            <el-radio-button label="1">盘亏</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" class="">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="assetPanConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  import AssetDetail from './assetDetail'
  export default {
    components: {
      UserInfo,
      AssetDetail
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        dialogVisible: false,
        form: {
          id: "",
          remark: "",
          type: "2"
        },

        // 详情
        noticeStatus: false,
        noticeDetail: '',
        isManager: true,

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表类型 0：我使用的  1：我负责的 2：待盘点
        relateType: "0",
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      this.getLists()
    },
    methods: {
      // 资产盘点
      assetPanConfirm() {
        console.log(this.form)
        ajax.post('/asset/pan', this.form, (res) => {
          this.loading = false
          this.getLists()
          this.dialogVisible = false
        })
      },
      AssetPanVisible(row) {
        this.form.id = row.id
        this.dialogVisible = true
      },


      // 资产确认 0:使用确认 1：负责人确认 2：财务确认 输入购置时间和金额
      assetConfirm(row, type) {
        let _form = {
          type: type,
          assetId: row.id
        }
        ajax.post('/asset/confirm', _form, (res) => {
          this.loading = false
          this.getLists()
        })
      },
      // 显示详情
      assetDetail(row) {
        let assetChangeDetail = {
          status: false,
          data: {}
        }
        this.$store.commit('set_assetChangeDetail', assetChangeDetail)

        let assetDetail = {
          status: true,
          data: row
        }
        this.$store.commit('set_assetDetail', assetDetail)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        if (this.relateType != 2) {
          // 负责/使用
          ajax.get('/asset/relate/me', {
            type: this.relateType
          }, (res) => {
            this.loading = false
            this.filterData = this.listData = res.vo.array
            this.getPaginationData()
          })
        } else {
          // 待盘点
          // 暂时取责任人的列表
          ajax.get('/asset/relate/me', {
            type: 1
          }, (res) => {
            this.loading = false
            this.filterData = this.listData = res.vo.array
            this.getPaginationData()
            // this.$forceUpdate();
          })

          // ajax.get('/asset/pan/zr/list', {
          //   year: (new Date()).getFullYear()
          // }, res => {
          //   this.loading = false
          //   this.filterData = this.listData = res.vo.list
          //   this.getPaginationData()
          // })
        }
      },
    },
    watch: {
      'relateType'() {
        this.filterData = this.listData = []
        this.getLists()
        let assetDetail = {
          status: false,
          data: ''
        }
        this.$store.commit('set_assetDetail', assetDetail)
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/myList.vue